// extracted by css-extract-rspack-plugin
export default {"container":"ClientConfirmations-module__container__rTRET","text":"ClientConfirmations-module__text__Hp24d"};